// import Swiper bundle with all modules installed
//import Swiper from 'swiper/bundle';

// import Swiper with navigation bundle
import Swiper, { Navigation, Autoplay, EffectFade } from 'swiper';

// configure Swiper to use modules
Swiper.use([Navigation, Autoplay, EffectFade]);

// import Swiper styles
//import 'swiper/swiper-bundle.css';

// single slide, centered, autoplay
// not supported in IE11
let isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
if (!isIE11) {
    const swiper = new Swiper('.js-swiper', {
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        autoplay: {
            delay: 8000,
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        keyboard: true,
        loop: true,
        speed: 600
    });
}